@if (description) {
  <div class="pinned">
    <div class="title">
      <h1>{{ description.title | translate }}</h1>
    </div>
    <div class="buttons">
      @if (count) {
        <label class="count">{{ 'results' | plural:count | translate:{value: count.toLocaleString()} }}</label>
      }
      <bst-table-options-button [count]="filterCount" (open)="events.next(DualAxisEvent.OPENFILTERS)"></bst-table-options-button>
      @if (description.canAdd) {
        <button nbButton [shape]="'semi-round'" type="button" [size]="'small'" [status]="'primary'" (click)="newDirectoryItem()"><nb-icon [icon]="'plus-outline'"></nb-icon>{{ 'additem' | translate:{value: description.title} }}</button>
      }
    </div>
  </div>
}
@if (description) {
  <bst-dual-axis [tag]="'dir_'+name" [delegate]="this"></bst-dual-axis>
}

<ng-template #cellTemplate let-dir="row" let-column="column" let-node="node">
  @switch (column.name) {
    @case ('editings') {
      <div>
      </div>
    }
    @default {
      <!-- For select columns with a list, look up the display name -->
      @if (column.type === 'select' && column.list) {
        <span>{{ getSelectDisplayValue(dir, column) }}</span>
      }
      @if (column.type !== 'select' || !column.list) {
        <span>{{ dir[column.name] || null }}</span>
      }
    }
  }
</ng-template>
